import { useLocale } from "../hooks/useLocale";
import type { Locale } from "../i18n/types";

/**
 * Language toggle control — switches between EN and ES.
 * Accessible via keyboard (Enter/Space) with ARIA label.
 */
export function LanguageSwitcher() {
  const { locale, setLocale, t } = useLocale();

  function handleToggle() {
    const next: Locale = locale === "en" ? "es" : "en";
    setLocale(next);
  }

  return (
    <button
      type="button"
      className="lang-switcher"
      onClick={handleToggle}
      aria-label={t("aria.languageSwitcher")}
    >
      <span className={locale === "en" ? "active" : ""}>EN</span>
      <span className={locale === "es" ? "active" : ""}>ES</span>
    </button>
  );
}
